/* gallery v1.0.0 */
(function () {
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-gallery-open]');
    if (open) {
      var dialog = document.getElementById(open.dataset.galleryOpen + '-modal');
      var field = dialog.querySelector('[name="contact[information_request_for]"]');
      if (field) field.value = open.dataset.galleryTitle;
      dialog.showModal();
      return;
    }
    var close = e.target.closest('[data-gallery-close]');
    if (close) { close.closest('dialog').close(); return; }

    var nav = e.target.closest('[data-gallery-nav]');
    if (nav) {
      var track = nav.closest('.gallery__slider').querySelector('.gallery__track');
      track.scrollBy({ left: track.clientWidth * (nav.dataset.galleryNav === 'next' ? 1 : -1), behavior: 'smooth' });
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('gallery__modal')) e.target.close();
  });

  // reopen after submit to show success / errors
  document.querySelectorAll('dialog[data-gallery-autoopen]').forEach(function (d) { d.showModal(); });
})();
